import { render, staticRenderFns } from "./MessageLink.vue?vue&type=template&id=1e3324e5&scoped=true&"
import script from "./MessageLink.vue?vue&type=script&lang=ts&"
export * from "./MessageLink.vue?vue&type=script&lang=ts&"
import style0 from "./MessageLink.vue?vue&type=style&index=0&id=1e3324e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3324e5",
  null
  
)

export default component.exports